import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { ArtstuffHeaderComponent } from './artstuff-header-component/artstuff-header.component';
import { ArtstuffRangePanelComponent } from './artstuff-header-component/artstuff-range-panel.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [ArtstuffHeaderComponent, ArtstuffRangePanelComponent],
  imports: [CommonModule, MatFormFieldModule, TranslateModule, MatButtonModule, MatIconModule, FormsModule, MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule],
})
export class TimePickerModule { }
